// web-rnw twin of ./dismissSoftKeyboard.ts, deliberately a NO-OP, and the
// reason is a defect, not a shrug.
//
// ⛔ react-native-web implements `Keyboard.dismiss()` as
// `TextInputState.blurTextInput(currentlyFocusedField())`, i.e. a bare DOM
// `.blur()` with no `.focus()` behind it. On a desktop browser
// `document.activeElement` then falls back to `<body>`, so anyone driving the
// logger from the keyboard loses their place and restarts the tab order from
// the top of the page: WCAG SC 2.4.3 (Focus Order), and it would be live
// today: the logger (`apps/web-rnw/src/WorkoutsScreen.tsx:310`) and the
// exercise picker both mount on web and call this.
// Measured in RNW's own source during the a11y audit of LG-69, 2026-09-04.
//
// And on the web there is nothing to buy with that cost: the dismissal exists
// because a SOFT keyboard covers the docked rest bar, and a desktop browser has
// no soft keyboard. So the platform that pays the price is the one that gets no
// benefit. Doing nothing is the correct behaviour here, not a fallback.
//
// A touch browser does raise a soft keyboard. Decided (#225, 02/10): the tap
// that completes a set moves focus onto the completed row, never to <body>,
// and that closes the keyboard. That is `focusLandedRow` below.
export const dismissSoftKeyboard = (): void => {};

// Fine pointer (desktop): nothing. Coarse pointer: focus the row's real button.
// (This package compiles without the DOM lib, hence the local shapes.)
declare const window: {
  matchMedia?: (q: string) => { matches: boolean };
} | undefined;
type Focusable = { focus?: (o: { preventScroll: boolean }) => void } | null;

export const focusLandedRow = (node: unknown): void => {
  if (typeof window === 'undefined') return;
  if (!window.matchMedia?.('(pointer: coarse)').matches) return;
  (node as Focusable)?.focus?.({ preventScroll: true });
};
